import { AppRoutes } from "../../lib/common/AppRoutes";

export default function Dissemination() {
  return (
    <div className="prose">
      <h1 className="hero__title">{AppRoutes.DISSEMINATION.title}</h1>
      <p>
        Coming Soon.
      </p>
    </div>
  );
}
